import { createSlice } from '@reduxjs/toolkit'

export const previewCurrentSlice = createSlice({
    name: 'previewCurrent',
    initialState: {
        diagram: undefined,
    },
    reducers: {
        setPreviewCurrentRedux: (state, action) => {
            state.diagram = action.payload;
        },
        clearPreviewCurrentRedux: (state) => {
            state.diagram = undefined;
        },
    },
})

export const { setPreviewCurrentRedux, clearPreviewCurrentRedux } = previewCurrentSlice.actions;

export const getPreviewCurrentRedux = (state) => state.previewCurrent.diagram;

export default previewCurrentSlice.reducer